// src/themes/lino/elements/Header/HeaderContainer.tsx
'use client';

import { ReactNode } from 'react';
import { useHeaderScrolled } from '@/core/hooks/use-header-scrolled';
import { useIsHome } from '@/core/hooks/use-is-home';
import { useMegaMenuStore } from '@/stores/megaMenuStore';
import { cn } from '@/core/lib/utils';
import { useHeaderScrollDirection } from '@/core/hooks/use-header-scroll-direction';

type HeaderContainerProps = {
    children: ReactNode;
};

export default function HeaderContainer({ children }: HeaderContainerProps) {
    const scrolled = useHeaderScrolled();
    const { hidden, floating } = useHeaderScrollDirection();
    const isHome = useIsHome();
    const isMegaMenuOpen = useMegaMenuStore(s => s.isOpen);

    // وقتی منو باز باشه هدر همیشه باید در دسترس بمونه، نه مخفی بشه نه شناور
    const isHidden = hidden && !isMegaMenuOpen;
    const isFloating = floating && !isMegaMenuOpen;

    const isTransparent = isHome && !scrolled && !isMegaMenuOpen;
    const isFloatingCard = !isTransparent;

    return (
        <div
            className={cn(
                'fixed top-0 inset-x-0 z-50 print:hidden mt-6',
                'transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]',
                isHidden && '-translate-y-[calc(100%+2rem)]'
            )}
        >
            <header
                data-scrolled={scrolled}
                data-transparent={isTransparent}
                data-floating={isFloating}
                className={cn(
                    'group grid grid-cols-3 items-center',
                    'text-primary-900 data-[transparent=true]:text-primary-0',
                    'transition-[background-color,box-shadow,border-radius,color,margin,padding,backdrop-filter] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]',
                    // ارتفاع هدر ثابته و بین حالت اسکرول‌شده و نشده تغییر نمی‌کنه
                    'h-16',
                    isFloating
                        ? [
                            // حالت شناور: فاصله از دو طرف، نیمه‌شفاف با بلور، گوشه‌های گرد (نه کاملاً گرد/کپسولی) — مثل oura موقع اسکرول به بالا
                            'mx-4 sm:mx-6 lg:mx-10',
                            'rounded-2xl',
                            'bg-primary-900/5 backdrop-blur-xl',
                            'text-primary-0',

                            'px-5 sm:px-7',
                        ]
                        : [
                            'mx-0 px-5 sm:px-8 lg:px-12',
                            isTransparent ? 'bg-transparent' : 'bg-primary-50',
                            isFloatingCard &&
                            (isMegaMenuOpen
                                ? ' -mt-6 shadow-[0_10px_28px_-14px_rgba(0,0,0,0.2)]'
                                : 'rounded-b-[1.75rem]'),
                            scrolled &&
                            !isTransparent &&
                            !isMegaMenuOpen &&
                            'shadow-[0_10px_28px_-14px_rgba(0,0,0,0.2)]',
                        ]
                )}
            >
                {children}
            </header>
        </div>
    );
}